import { useTranslation } from 'react-i18next';
import { TextField } from '@cmsgov/ds-healthcare-gov';

type Props = {
  name: string | null | undefined;
  updateHouseholdMemberName: (value: string) => void;
};

const HouseholdMemberInfo = ({ updateHouseholdMemberName, name }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="ds-l-row ds-u-margin-bottom--3">
      <div className="ds-l-col--12">
        <TextField
          label={t('estimatorNameLabel')}
          type="text"
          name="household-member-name"
          hint={t('optional')}
          onChange={(event) => updateHouseholdMemberName(event.target.value)}
          value={name ? name : ''}
        />
      </div>
    </div>
  );
};

export default HouseholdMemberInfo;
